import { Injectable } from '@angular/core';
import { AppSettingsDto } from '@app/generated/model';
import { AppControllerService } from '@app/generated/service';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import { BehaviorSubject, Observable } from 'rxjs';

export enum ApplicationMode {
  ONLINE,
  OFFLINE,
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private settings: AppSettingsDto;
  private mode: BehaviorSubject<ApplicationMode> = new BehaviorSubject(
    navigator.onLine ? ApplicationMode.ONLINE : ApplicationMode.OFFLINE,
  );

  constructor(private appController: AppControllerService) {}

  async load(): Promise<void> {
    this.settings = await this.appController.getSettings().toPromise();
  }

  get(): AppSettingsDto {
    return this.settings;
  }

  getMode(): Observable<ApplicationMode> {
    return this.mode;
  }

  setMode(mode: ApplicationMode) {
    this.mode.next(mode);
  }

  createWebSocketClient(reconnectDelay: number) {
    return new Client({
      webSocketFactory: () => new SockJS(this.get().webSocket.url),
      reconnectDelay,
    });
  }
}
